<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <router-view></router-view>
    <div id="faixa" v-if="verificaAmbiente()">{{ retornaAmbiente() }}</div>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import locale from "./locale";

import dotenv from "dotenv";
dotenv.config();

export default {
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
  },
  async created() {
    try {
      this.$validator.localize("ptBr", locale);
      // await this.$auth.renewTokens();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    verificaAmbiente() {
      if (process.env.VUE_APP_ENV != "prod") return true;
      else return false;
    },
    retornaAmbiente() {
      return process.env.VUE_APP_ENV;
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch("updateWindowWidth", event.currentTarget.innerWidth);
    },
  },
  mounted() {
    this.verificaAmbiente();
    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.$store.dispatch("updateWindowWidth", window.innerWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
};
</script>
<style>
input.has-error,
div.has-error.vs-input input,
div.has-error.v-select {
  border: 1px solid rgba(var(--vs-danger), 1) !important;
  border-radius: 5px;
}
div.has-error.v-select .vs__dropdown-toggle {
  border: 0px !important;
}
#faixa {
  background-color: red;
  color: white;
  font-size: 20px;
  position: fixed;
  bottom: 47px;
  width: 300px;
  text-align: center;
  text-transform: uppercase;
  right: -45px;
  -ms-transform: rotate(-30deg);
  -webkit-transform: rotate(-30deg);
  transform: rotate(-30deg);
  z-index: 999;
}
</style>
